import { HelpPage } from "./HelpPage";

const pages = {
  HelpPage,
};
export default pages;
